var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"space_utilization_top10",attrs:{"id":"space_utilization_top10"}})
}
var staticRenderFns = []

export { render, staticRenderFns }